module.exports = __webpack_public_path__ + "static/media/doyouknow.53901004.png";